
















import { Vue, Component, Prop } from 'vue-property-decorator';

import IconArrow from '@/components/icons/Arrow.vue';

export type ArrowsDirection = 'vertical' | 'horizontal';

@Component({
    components: {
        IconArrow,
    },
})
export default class WrapperArrows extends Vue {
    @Prop({ default: 'vertical' }) readonly direction!: ArrowsDirection
    
    goBack() {
        this.$emit('back');
    }

    goNext() {
        this.$emit('next');
    }
}
